// TODO: some of this is duplicated in the training-profile-engine app,
// could move to a shared location
import { useQuery } from "@tanstack/react-query";
import { getSharedApiClient } from "@/shared-utils";
import { type AllowedPartners, type AllowedTenants, type TemplateBase, TemplateStatus } from "../types/template";

const getTemplatesByPartner = async (
    tenant: AllowedTenants,
    partner: AllowedPartners,
    correlationId: string,
): Promise<TemplateBase[]> => {
    const response = await getSharedApiClient().get(`api/expert-university/v1/templates/${tenant}/${partner}`, {
        headers: {
            "x-ewp-correlation-id": correlationId,
        },
    });

    const templates = await response.json<TemplateBase[]>();
    return templates.filter((template) => template.status === TemplateStatus.IN_PRODUCTION);
};

export const useTrainingProfiles = (tenant: AllowedTenants, partner: AllowedPartners, correlationId: string) => {
    const { data } = useQuery({
        queryKey: ["training-profiles"],
        queryFn: () => getTemplatesByPartner(tenant, partner, correlationId),
    });

    return data;
};
